// App
import React from 'react';

// Components
import { SkeletonCard } from 'app/shared/modules/listing-cards/ListingCardV3';

interface ListSkeletonProps {
  count: number;
}

const ListSkeleton: React.FC<ListSkeletonProps> = ({ count }) => {
  const iterator = [...Array(count).keys()];

  return (
    <ul>
      {iterator.map((_, idx) => (
        <li key={`skeleton-list-${idx}`}>
          <SkeletonCard />
        </li>
      ))}
    </ul>
  );
};

export default ListSkeleton;
